module.exports = __webpack_public_path__ + "static/media/blue-tl.acac3d90.svg";